import { assertNever } from '../amorg-common';
import { applicationEndpoints } from '../amorg-common/applicationEndpoints';
import { EmployeeToken, UserToken } from '../amorg-common/DTOs/Token';


const baseUrl = `${window.location.protocol}//${window.location.host}`

export const appUrlBuilder = {

    home: {
        build:(token:UserToken | EmployeeToken):string => {
            if(!token)
            {
                throw new Error("User token is required to build home url");
            }
            if(token.type === 'employee')
            {
                return `${baseUrl}/portal/${token.siteId}`;
            }
            else {
                if(token.permissionGroupId === '')
                {
                    throw new Error("user must have a permission group to access the app");
                }
                else if(token.permissionGroupId === 'anonymous')
                {
                    throw new Error("user cannot be anonymous");
                }
                else if(token.permissionGroupId === 'employee')
                {
                    throw new Error("user cannot have employee permission group");
                }
                else if(token.permissionGroupId === 'user')
                {
                    return `${baseUrl}/user/overview`;
                }
                else if(token.permissionGroupId === 'member' || token.permissionGroupId === 'siteadmin' || token.permissionGroupId === 'superadmin')
                {
                    if(token.features.includes('Articles') && token.features.includes('ArticleLandingPage'))
                    {
                        return `${baseUrl}/articles`;
                    }
                    else
                    {
                        return `${baseUrl}/dashboard`;
                    }
                }
                else 
                {
                    assertNever(token.permissionGroupId);
                }
            }
        }
    },


    actionPlan:{
        public:(linkId:string, siteId:string):string => {
            return `${baseUrl}/actionplans/public/${linkId}@${siteId}`
        },
        fromDashboard:(actionPlanId:string):string => {
            return `${baseUrl}/actionplans/${actionPlanId}?retdist=dashboard`
        },
        fromArticle:(actionPlanId:string, articleId:string):string => {
            return `${baseUrl}/actionplans/${actionPlanId}?retdist=article&retid=${articleId}`
        },
        list: () => `${baseUrl}/actionplans`,
    },

    workPlaceAssessment:{
        internal:(activityId:string):string => {
            return `${baseUrl}/workplaceassessments/${activityId}`
        },
        list:():string => {
            return `${baseUrl}/workplaceassessments`
        }
    },
    annualWorkGroupStatus:{
        internal:(activityId:string):string => {
            return `${baseUrl}/annualworkgroupstatus/${activityId}`
        },
        list:():string => {
            return `${baseUrl}/annualworkgroupstatus`
        }
    },
    safetyInspection:{
        internal:(activityId:string):string => {
            return `${baseUrl}/safetyinspections/${activityId}`
        },
        list:():string => {
            return `${baseUrl}/safetyinspections`
        }
    },
    workGroupMeeting:{
        internal:(activityId:string):string => {
            return `${baseUrl}/workgroupmeetings/${activityId}`
        },
        list:():string => {
            return `${baseUrl}/workgroupmeetings`
        }
    },

    portal:{
        login: (siteId:string) => `${baseUrl}${applicationEndpoints.portal_login_siteId.replace(':siteId', siteId)}`,
        loginAccessKey: (siteId:string, accessKey:string) => `${baseUrl}${applicationEndpoints.portal_access_key_siteId_accessKey.replace(':siteId', siteId).replace(':accessKey', accessKey)}`,  
    },

    articles:{
        publicLink: (articleId:string, siteId:string) =>
                `${baseUrl}${applicationEndpoints.public_article_siteId_articleId.replace(':siteId', siteId).replace(':articleId', articleId)}`,
    }
}

